import 'scss/member/index.scss'
import 'scss/member/member-equity.scss'
import { memberEquityData, memberEquityImgData } from 'js/libs/json/member-equity'
import { layer } from 'js/libs/utils-layer'
import { config } from 'config'
import { showLoginModal } from 'js/libs/utils-login'
import { getMemberLevel, getMemberBenefit, getMemberLevelBenefit, getLevelNum, getLevelEquity } from 'js/api/member'
import star from 'assets/img/member/full-star.png'
// 引入 ECharts 主模块
var echarts = require('echarts/lib/echarts')
// 引入柱状图
require('echarts/lib/chart/bar')
require('echarts/lib/chart/line')

var myChart = echarts.init(document.getElementById('chart'))

function dataInit (labelName) {
  let dataSet = [
    { level: 'L0', value: 0.00001 },
    { level: 'L1', value: 0.00001 },
    { level: 'L2', value: 2 },
    { level: 'L3', value: 4 },
    {
      level: 'L4',
      value: 6
    },
    { level: 'L5', value: 8 },
    { level: 'L6', value: 11 },
    { level: 'L7', value: 14 }
  ]
  dataSet.map(key => {
    if (key.level === labelName) {
      key['label'] = {
        'distance': 0
      }
    }
  })
  return dataSet
}

function tranNumber (num) {
  let numStr = num.toString()
  if (numStr.length < 5) {
    return numStr
  } else if (numStr.length > 8) {
    return Math.round((num / 100000000) * 100) / 100 + '亿'
  } else if (numStr.length >= 5 && numStr.length <= 8) {
    return Math.round((num / 10000) * 100) / 100 + '万'
  }
}

var tabIndex = 0
var levelName = 'L7'
var memberData = memberEquityData(levelName)
var memberImgData = memberEquityImgData()
var memberHaveEquity = []
var member = ((_member) => {
  _member.init = () => {
    var strHtml = ''
    var len = memberData.length
    $('.member-equity').html(strHtml)
    for (var i = 0; i < len; i++) {
      var divHtml = `<div class="member-equity-box">
                <div data-value="${i}" class="member-equity-box-image ${!memberData[i].type ? 'image-disabled' : ''}" style="background-image: url(${memberData[i].type ? memberImgData[i].unselected : memberImgData[i].unpower})"></div>
                <div class="member-equity-box-title ${!memberData[i].type ? 'title-disabled' : ''}">${memberData[i].title}</div>
                <div class="member-equity-box-btn ${!memberData[i].type ? 'btn-disabled' : ''}">
                    <a data-value="${i}" class="memberEquityBtn ${!memberData[i].type ? 'equity-not-allowed' : ''}">${memberData[i].btnTitle}</a>
                </div>
            </div>`
      strHtml += divHtml
    }
    $('.member-equity').html(strHtml)
  }
  _member.drawChart = (labelName) => {
    // 绘制图表
    myChart.setOption({
      grid: {
        x: 20,
        y: 0
      },
      xAxis: {
        axisLabel: {
          show: false
        },
        minorTick: {
          show: false
        },
        nameTextStyle: {
          color: '#333',
          fontSize: 16
        },
        data: ['L0', 'L1', 'L2', 'L3', 'L4', 'L5', 'L6', 'L7'],
        axisTick: {
          show: false
        },
        axisPointer: {
          label: {
            show: false
          }
        },
        axisLine: {
          lineStyle: {
            color: '#b4ccff'
          },
          symbol: ['none', 'arrow'],
          symbolSize: [8, 10]
        }
      },
      yAxis: [
        {
          max: 18,
          nameLocation: 'center',
          nameRotate: 90,
          left: 0,
          axisLabel: {
            show: false,
            interval: 0
          },
          minorTick: {
            show: false
          },
          nameTextStyle: {
            color: '#333',
            fontSize: 16
          },
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#b4ccff'
            },
            symbol: ['none', 'arrow'],
            symbolSize: [8, 10]
          }
        },
        {
          type: 'value',
          name: '趋势',
          min: 0,
          max: 25,
          interval: 5,
          axisLabel: {
            formatter: '{value}'
          },
          show: false
        }
      ],
      series: [
        {
          type: 'bar',
          cursor: 'default',
          data: dataInit(labelName),
          label: {
            show: true,
            position: 'top',
            distance: 15,
            formatter: (params) => {
              if (params.data.level === labelName) {
                return '{color1|' + params.data.level + '}' + '\n' + '{color3|}'
              } else {
                return '{color2|' + params.data.level + '}'
              }
            },
            rich: {
              color1: {
                backgroundColor: '#ff9c00',
                color: '#fff',
                borderRadius: 5,
                fontSize: 20,
                padding: [4, 8, 4, 8]
              },
              color2: {
                backgroundColor: '#b4ccff',
                color: '#fff',
                borderRadius: 5,
                fontSize: 16,
                padding: [4, 8, 4, 8],
                margin: [0, 0, 20, 0],
                border: [0, 0, 10, 0],
                verticalAlign: 'top',
                borderWidth: 10,
                textShadowOffsetY: 10,
                distance: 10
              },
              color3: {
                backgroundColor: {
                  image: star
                },
                height: 40,
                width: 40,
                textAlign: 'center',
                align: 'center',
                lineHeight: 40
              }
            }

          },
          barWidth: 22,
          itemStyle: {
            color: function (params) {
              let colorList = []
              for (let i = 0; i < 8; i++) {
                if (params.data.level === labelName) {
                  colorList.push(new echarts.graphic.LinearGradient(
                    0, 0, 0, 1,
                    [
                      { offset: 0, color: '#ffc03a' },
                      { offset: 0.5, color: '#ffcf67' },
                      { offset: 1, color: '#ffd272' }
                    ]
                  ))
                } else {
                  colorList.push(new echarts.graphic.LinearGradient(
                    0, 0, 0, 1,
                    [
                      { offset: 0, color: '#338aff' },
                      { offset: 0.5, color: '#67a8ff' },
                      { offset: 1, color: '#77b2ff' }
                    ]
                  ))
                }
              }
              // 对每个bar显示一种颜色
              return colorList[params.dataIndex]
            },
            barBorderRadius: [6, 6, 0, 0]
          },
          clip: false
        },
        {
          data: [
            { level: 'L0', value: 3.2 },
            { level: 'L1', value: 5 },
            { level: 'L2', value: 7.2 },
            { level: 'L3', value: 9.8 },
            { level: 'L4', value: 12.8 },
            { level: 'L5', value: 16.2 },
            { level: 'L6', value: 20 },
            { level: 'L7', value: 24.2, symbol: 'arrow', symbolSize: 12, symbolRotate: 320 }
          ],
          type: 'line',
          smooth: true,
          clip: false,
          yAxisIndex: 1,
          hoverAnimation: false,
          legendHoverLink: false,
          cursor: 'default',
          symbol: 'none',
          itemStyle: {
            color: '#ffbd31'
          }

        }]
    })
  }
  _member.showModel = async (index) => {
    var num = Number(index)
    $('.equity-header .equity-header-box').removeClass('equity-header-box-select')
    $('.equity-header').find('.equity-header-box').eq(num >= 5 ? num - 5 : num).addClass('equity-header-box-select')
    for (var i = 0; i < 5; i++) {
      if ($('.equity-header-box .equity-header-image img')[i]) {
        if (i === (num >= 5 ? num - 5 : num)) {
          $('.equity-header-box .equity-header-image img')[i].src = memberImgData[i + (num >= 5 ? 5 : 0)].selected
        } else {
          $('.equity-header-box .equity-header-image img')[i].src = memberImgData[i + (num >= 5 ? 5 : 0)].unselected
        }
      }
    }
    tabIndex = (num >= 5) ? 5 : 0
    var id = memberData[num].id
    var res = await getMemberLevelBenefit(id)
    if (res && res.code === 0) {
      var strHtml = ''
      switch (num) {
        case 0:
          strHtml += `<div class="member-equity-table-header">
        <table class="member-equity-table">
        <tr>
            <th>语音能力</th>
            <th>服务量</th>
            <th>服务有效期</th>
            <th>操作</th>
        </tr>
        </table>
        </div>
        <div class="member-equity-table-body">
        <table class="member-equity-table">`
          res.data.forEach((a) => {
            strHtml += `<tr>
            <td>${a.name}</td>
            <td>${a.num}</td>
            <td>${a.expireDay}</td>
            <td>${a.usable === 0 ? '<a class="unreceive-equity-btn">无权限</a>' : (a.usable === 1 ? '<a data-busin="' + a.busin + '" data-mark="' + a.mark + '" class="receive-equity-btn">领取</a>' : '<a class="unreceive-equity-btn">已领取</a>')}</td>
        </tr>`
          })
          strHtml += `</table>
        </div>
        <p><span class="mark-image">!</span>赠送的服务量自领取之日起90天内有效。</p>`
          $('#member-equity-table').html(strHtml)
          break
        case 1:
          strHtml += `<div class="member-equity-table-header">
        <table class="member-equity-table">
        <tr>
            <th>用户等级</th>
            <th>语音能力</th>
            <th>服务量</th>
            <th>服务有效期</th>
            <th>操作</th>
        </tr>
        </table>
        </div>
        <div class="member-equity-table-body">
        <table class="member-equity-table">`
          res.data.forEach((a) => {
            strHtml += `<tr>
            <td>${a.level}</td>
            <td>${a.name}</td>
            <td>${a.num.replace(/\r\n/g, '<br/>')}</td>
            <td>${a.expireDay}</td>
            <td>${a.usable === 0 ? '<a class="unreceive-equity-btn">无权限</a>' : (a.usable === 1 ? '<a data-busin="' + a.busin + '" data-mark="' + a.mark + '" class="receive-equity-btn">领取</a>' : '<a class="unreceive-equity-btn">已领取</a>')}</td>
        </tr>`
          })
          strHtml += `</table>
        </div>
        <p><span class="mark-image">!</span>赠送的服务量自领取之日起1年内有效。</p>`
          $('#member-equity-table').html(strHtml)
          break
        case 2:
          strHtml += `<div class="member-equity-table-header">
        <table class="member-equity-table">
        <tr>
            <th>用户等级</th>
            <th>乐享会员类型</th>
            <th>会员有效期</th>
            <th>操作</th> 
        </tr>
        </table>
        </div>
        <div class="member-equity-table-body">
        <table class="member-equity-table">`
          res.data.forEach((a) => {
            strHtml += `<tr>
            <td>${a.level}</td>
            <td>${a.num}</td>
            <td>${a.expireDay}</td>
            <td>${a.usable === 0 ? '<a class="unreceive-equity-btn">无权限</a>' : (a.usable === 1 ? '<a data-model="2" data-mark="' + a.mark + '" class="receive-equity-btn">领取</a>' : '<a class="unreceive-equity-btn">已领取</a>')}</td>
        </tr>`
          })
          strHtml += `</table>
        </div>
        <p><span class="mark-image">!</span>赠送的会员有效期自领取之日起的规定时间内有效。</p>`
          $('#member-equity-table').html(strHtml)
          break
        case 3:
          strHtml += `<div class="member-equity-table-header">
        <table class="member-equity-table">
        <tr>
            <th>用户等级</th>
            <th>语音套餐</th>
            <th>抵用券折扣</th>
            <th>抵用券有效期</th>
            <th>操作</th>
        </tr>
        </table>
        </div>
        <div class="member-equity-table-body">
        <table class="member-equity-table">`
          res.data.forEach((a) => {
            strHtml += `<tr>
            <td>${a.level}</td>
            <td style="width: 100px;">${a.name}</td>
            <td>${a.num}</td>
            <td>${a.expireDay}</td>
            <td>${a.usable === 0 ? '<a class="unreceive-equity-btn">无权限</a>' : (a.usable === 1 ? '<a data-model="3" data-mark="' + a.mark + '" class="receive-equity-btn">领取</a>' : '<a class="unreceive-equity-btn">已领取</a>')}</td>
        </tr>`
          })
          strHtml += `</table>
        </div>
        <p><span class="mark-image">!</span>1、语音套餐的详细信息请到各语音能力的产品页查看。<br>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2、赠送的抵扣券有效期自领取之日起的180天内有效。</p>`
          $('#member-equity-table').html(strHtml)
          break
        default:
          var content = ''
          switch (num) {
            case 4:
              content = `<div class="acitivity-not-start" style="opacity: 0;">当前活动尚未开始，敬请期待</div>
              <div class="equity-title" style="margin-top: 10px;">服务市场入驻免押金</div>
              <p class="equity-content-p">讯飞AI服务市场面对愈来愈多企业致力于AI升级的现状需求，一方面为开发方研发的产品，提供强大的品牌背书和低成本的获客渠道；另一方面为客户方提供严选后的AI产品解决方案，将上下游无缝连接起来，提供多元化服务平台、赋能创新型服务、打造全新交互式体验。目前AI服务市场已入驻服务商超过200+家，累计注册企业客户数超过40000+家。</p>
              <div style="text-align: center;margin-top: 10px;">
              <a class="settle" href="http://www.aifuwus.com/user/enterinfo" target="_blank">立即入驻</a>
              </div>`
              break
            case 5:
              content = `<div class="acitivity-not-start">当前活动尚未开始，敬请期待</div>
              <div class="equity-title">全球1024开发者大会</div>
              <p class="equity-content-p">全球1024开发者节是以A.I.开发者为受众群体的人工智能盛会，由科大讯飞公司发起并主办。选择在每年的10月24日举行开幕式，是因为在计算机世界中1024是2的十次方，是二进制计数的基本计量单位之一，是1KB的字节数，也因此组成了程序中最基础的基因序列。秉持“开放·合作·生态·共享”的理念，不断丰富“1024”的内核元素。全球1024开发者节希望用更新更全的人工智能技术和产品促进跨行业链接、多领域碰撞、新技术升级，以科技之光、生态之念，立足当下、放眼未来，打造全域A.I.新世界。</p>`
              break
            case 6:
              content = `<div class="acitivity-not-start">当前活动尚未开始，敬请期待</div>
              <div class="equity-title">线下技术沙龙邀约</div>
              <p class="equity-content-p">我们不定期会举办讯飞开放平台技术沙龙，为优质开发者提供最新的技术分析和技术探讨的平台，每期将优先邀请高等级用户，为用户提供面对面技术交流的机会。</p>`
              break
            case 7:
              content = `<div class="acitivity-not-start" style="opacity: 0;">当前活动尚未开始，敬请期待</div>
              <div class="equity-title" style="margin-top: 25px;">服务市场品牌加持</div>
              <p class="equity-content-p">提供AI产业链各环节优质的资源，凭借科大讯飞的技术优势和AI 市场的行业资源，整合优质开发者、工业设计资源、销售渠道、生产供应链资源等，为用户提供核心技术能力、行业解决方案、开发团队、工业设计、品牌策划、供应链、销售渠道等多项服务。</p>`
              break
            case 8:
              content = `<div class="acitivity-not-start" style="opacity: 0;">当前活动尚未开始，敬请期待</div>
              <div class="equity-title" style="margin-top: 25px;">专属服务集群</div>
              <p class="equity-content-p">账户下所有应用（APPID）将自动迁入到高等级用户专属服务集群，届时将最高获得99.95%的服务可用性，在服务高峰期，相较于普通用户，我们将优先保障高等级用户的服务稳定。</p>`
              break
            case 9:
              content = `<div class="acitivity-not-start" style="opacity: 0;">当前活动尚未开始，敬请期待</div>
              <div class="equity-title" style="margin-top: 25px;">1V1技术支持</div>
              <p class="equity-content-p">我们为高等级用户提供1V1微信及电话技术支持，快速对接您的技术需求，保障用户能够及时解决技术问题，为产品护航。</p>`
              break
          }
          strHtml += `<div class="member-equity-content-no-table">
            <div class="member-equity-content member-equity-content-bg">${content}</div>
          </div>`
          $('#member-equity-table').html(strHtml)
          break
      }
    } else {
      var str = `<div style="text-align: center;margin-top: 100px;color: #666666;">暂无数据</div>`
      $('#member-equity-table').html(str)
    }
  }
  _member.showEquityDialog = (inputArr, type = 'left') => {
    var strHtml = ''
    var arr = []
    var len = inputArr.length
    if (len > 5 && type === 'left') {
      arr = inputArr.slice(0, 5)
      $('.equity-header-arrow-left').css('opacity', 0)
      $('.equity-header-arrow-right').css('opacity', 1)
    }
    if (len > 5 && type === 'right') {
      arr = inputArr.slice(5, len)
      $('.equity-header-arrow-left').css('opacity', 1)
      $('.equity-header-arrow-right').css('opacity', 0)
    }
    if (len <= 5) {
      arr = inputArr.slice(0, len)
      $('.equity-header-arrow-left').css('opacity', 0)
      $('.equity-header-arrow-right').css('opacity', 0)
    }
    arr.forEach((a, i) => {
      strHtml += `<div class="equity-header-box" data-value="${i}">
        <div class="equity-header-image">
            <img src="${memberImgData[(type === 'right' && len > 5) ? 5 + i : i].unselected}"/>
            <div style="line-height: 16px;">${_member.titleHandle(a.benefitName || a.title)}</div>
        </div>
        <div class="equity-header-bottom">
        </div>
    </div>`
    })
    $('.equity-header').html(strHtml)
  }
  _member.titleHandle = (title) => {
    var out = title
    switch (title) {
      case '服务市场入驻免押金':
        out = '服务市场<br>入驻免押金'
        break
      case '线下技术沙龙邀约':
        out = '线下技术<br>沙龙邀约'
        break
      case '服务市场品牌加持':
        out = '服务市场<br>品牌加持'
        break
    }
    return out
  }
  _member.getMemberLevel = async () => {
    var res = await getMemberLevel()
    if (res && res.code === 0) {
      let labelName = res.data.labelName
      memberData = memberEquityData(labelName)
      _member.getMemberBenefit()
      _member.drawChart(labelName)
      _member.getTableContent(labelName)
      _member.getLevelNum(labelName)
    }
    if (res && res.code === 80000) {
      $('.main-content').hide()
      showLoginModal()
    }
  }
  _member.getTableContent = (labelName) => {
    let content = ''
    for (let i = 0; i < 8; i++) {
      let isNow = ('L' + i === labelName)
      if (isNow) {
        $('.compare-table > tbody > tr').map(key => {
          let nowTd = $('.compare-table > tbody > tr').eq(key).find('td').eq(i + 1)
          nowTd.addClass('now-td')
          nowTd.prev().css('border-right', 'none')
        })
      }
      content += `
        <th order="L${i}" class="${isNow ? 'now-l' : ''}">
          ${isNow ? '<i class="star-flag"></i>' : ''}L${i}</th>`
    }
    $('.compare-thead').append(
      `<th>等级权益</th>` + content)
    $('.now-l').prev().css('border-right', 'none')
  }
  _member.getMemberBenefit = async () => {
    var res = await getMemberBenefit()
    if (res && res.code === 0) {
      var arr = res.data
      arr.forEach((a, i) => {
        memberData[i].id = arr[i].id
        memberData[i].type = arr[i].usable
      })
      _member.init()
      memberData.forEach(a => {
        if (a.type) {
          memberHaveEquity.push(a)
        }
      })
      _member.showEquityDialog(memberHaveEquity)
    }
  }
  _member.getLevelNum = async (labelName) => {
    var res = await getLevelNum()
    if (res && res.code === 0) {
      let r = res.data
      $('.server-day').text(r.serverDay)
      $('.sever-times').text(tranNumber(r.serverTimes))
      $('.real-fee').text(tranNumber(r.realFee))
    }
    $('.level-icon').addClass('level-' + labelName.slice(1, labelName.length))
  }
  _member.showFlower = () => {
    if ($('#flower-canvas').length === 0) {
      $('body').append('<canvas id="flower-canvas" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; pointer-events: none; z-index: 9999;"></canvas>')
    }
    const canvas = document.getElementById('flower-canvas')
    const ctx = canvas.getContext('2d')
    let particles = []
    const GRAVITY = 0.15
    const DRAG = 0.98

    function resizeCanvas () {
      canvas.width = window.innerWidth
      canvas.height = window.innerHeight
    }
    resizeCanvas()
    window.addEventListener('resize', resizeCanvas)

    function spawnConfetti (centerX, centerY, count = 180) {
      for (let i = 0; i < count; i++) {
        const baseAngle = -Math.PI / 2
        const spread = 0.6
        const angle = baseAngle + (Math.random() - 0.5) * spread
        const speed = 7 + Math.random() * 12
        const vx = Math.cos(angle) * speed * (0.8 + Math.random() * 0.5)
        const vy = Math.sin(angle) * speed * (0.8 + Math.random() * 0.5)
        const w = 3 + Math.random() * 6
        const h = 5 + Math.random() * 9
        const hue = Math.random() * 360
        const sat = 80 + Math.random() * 20
        const light = 50 + Math.random() * 30
        const color = `hsl(${hue}, ${sat}%, ${light}%)`
        const rot = Math.random() * Math.PI * 2
        const rotSpeed = (Math.random() - 0.5) * 0.15
        const life = 0.8 + Math.random() * 0.5

        particles.push({
          type: 'confetti',
          x: centerX,
          y: centerY,
          vx: vx,
          vy: vy,
          w: w,
          h: h,
          rot: rot,
          rotSpeed: rotSpeed,
          color: color,
          life: life
        })
      }
    }

    function updateParticles () {
      for (let i = particles.length - 1; i >= 0; i--) {
        const p = particles[i]
        p.vx *= DRAG
        p.vy *= DRAG
        p.vy += GRAVITY
        p.x += p.vx
        p.y += p.vy
        p.rot += p.rotSpeed
        p.life -= 0.003
        if (p.life <= 0 || p.y > canvas.height) {
          particles.splice(i, 1)
        }
      }
    }

    function drawParticles () {
      ctx.clearRect(0, 0, canvas.width, canvas.height)
      particles.forEach(p => {
        ctx.save()
        ctx.translate(p.x, p.y)
        ctx.rotate(p.rot)
        ctx.fillStyle = p.color
        ctx.globalAlpha = Math.max(0, p.life)
        ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h)
        ctx.restore()
      })
    }

    function loop () {
      updateParticles()
      drawParticles()
      if (particles.length > 0) {
        requestAnimationFrame(loop)
      } else {
        $('#flower-canvas').remove()
      }
    }

    spawnConfetti(canvas.width / 2, canvas.height / 2 + 200)
    loop()
  }

  _member.getLevelEquity = async (mark, model) => {
    var data = {
      mark: mark
    }
    var res = await getLevelEquity(data)
    if (res && res.code === 0) {
      _member.showFlower()
      if (model === '2') {
        $.alerts.alert('领取成功!', '前往会员中心', (res) => {
          if (res) {
            $('#popup_ok').removeClass('w160')
            var url = window.location.origin
            window.open(url + '/FunMember/center', '_blank')
          }
        })
        $('#popup_ok').addClass('w160')
      }
      if (model === '3') {
        $.alerts.alert('恭喜您！抵用券已领取成功，可在财务中心-优惠券查看')
      }
      _member.showModel(model)
    } else {
      if (res.code === 30006) {
        $.alerts.alert(res.desc, '去认证', (res) => {
          if (res) {
            window.open(`${config.CONSOLE}user/authentication`)
          }
        })
      } else {
        $.alerts.alert(res.desc || '领取失败!')
      }
    }
  }
  return _member
})({})

$(() => {
  function getQueryString (name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
    var r = window.location.search.substr(1).match(reg)
    if (r != null) {
      return unescape(r[2])
    }
    return null
  }
  setTimeout(() => {
    var tag = getQueryString('tag')
    if (tag === 'NewUser') {
      var $target = $('#my-equity')
      if ($target.length > 0) {
        $('html, body').animate({
          scrollTop: $target.offset().top
        }, 500, function () {
          // 自动点击“乐享会员试用”
          var $btn = $('.member-equity-box').filter(function () {
            return $(this).find('.member-equity-box-title').text().trim() === '乐享会员试用'
          }).find('.memberEquityBtn')

          if ($btn.length > 0) {
            $btn.click()
            // 等待弹窗加载并自动领取 L1
            var checkInterval = setInterval(function () {
              var $table = $('#member-equity-table')
              if ($table.find('tr').length > 0) {
                // 查找 L1 行
                var $l1Row = $table.find('tr').filter(function () {
                  return $(this).find('td').eq(0).text().trim() === 'L1'
                })
                // 查找“领取”按钮
                var $receiveBtn = $l1Row.find('.receive-equity-btn')
                if ($receiveBtn.length > 0 && $receiveBtn.text().trim() === '领取') {
                  clearInterval(checkInterval)
                  $receiveBtn.click()
                } else if ($l1Row.length > 0 && $receiveBtn.length === 0) {
                  // L1 行存在但没有领取按钮（可能已领取或无权限），停止轮询
                  clearInterval(checkInterval)
                }
              }
            }, 500)
            // 设置超时清除定时器，防止死循环
            setTimeout(() => clearInterval(checkInterval), 10000)
          }
        })
      } else {
        console.error('Target element #my-equity not found')
      }
    }
  }, 1000)
  member.getMemberLevel()
  $('.member-equity').on('click', '.memberEquityBtn', function () {
    var value = this.dataset.value
    var text = this.innerHTML
    tabIndex = 0
    if (text === '等级不足') {
      return false
    }
    // if (value === 4 || value === '4') {
    //   window.open('http://www.aifuwus.com/user/enterinfo', '_blank')
    //   return false
    // }
    value = Number(value)
    member.showEquityDialog(memberHaveEquity, value >= 5 ? 'right' : 'left')
    member.showModel(value)
    layer.open('.modal-member-equity')
    layer.open('.modal-layer')
  })
  $('.modal-member-equity .modal-close').click(() => {
    layer.close('.modal-member-equity')
    layer.close('.modal-layer')
    tabIndex = 0
  })
  $('.member-equity-header').on('click', '.equity-header-arrow-left', () => {
    tabIndex = 0
    member.showEquityDialog(memberHaveEquity, 'left')
    member.showModel(tabIndex)
  })
  $('.member-equity-header').on('click', '.equity-header-arrow-right', () => {
    tabIndex = 5
    member.showEquityDialog(memberHaveEquity, 'right')
    member.showModel(memberHaveEquity.length > 5 ? tabIndex : 0)
  })
  $('.equity-header').on('click', '.equity-header-box', (e) => {
    $('.equity-header-box').removeClass('equity-header-box-select')
    $(e.currentTarget).addClass('equity-header-box-select')
    var index = Number(e.currentTarget.dataset.value)
    for (var i = 0; i < 5; i++) {
      if ($('.equity-header-box .equity-header-image img')[i]) {
        if (i === index) {
          $('.equity-header-box .equity-header-image img')[i].src = memberImgData[i + tabIndex].selected
        } else {
          $('.equity-header-box .equity-header-image img')[i].src = memberImgData[i + tabIndex].unselected
        }
      }
    }
    member.showModel(index + tabIndex)
  })
  $('#member-equity-table').on('click', '.receive-equity-btn', (event) => {
    var mark = event.currentTarget.dataset.mark
    var busin = event.currentTarget.dataset.busin
    var model = event.currentTarget.dataset.model
    if (busin === undefined) {
      member.getLevelEquity(mark, model)
    } else {
      var url = config.CONSOLE + '/app/myapp?mark=' + mark + '&businessId=' + ((busin === 'null' || busin === 'undefined') ? '' : busin)
      window.open(url, '_blank')
    }
  })
  $('.member-equity').on('mouseenter', '.member-equity-box', (e) => {
    var el = $(e.currentTarget).find('.member-equity-box-image')
    var value = Number(el[0].dataset.value)
    if (memberData[value].type) {
      el.css('background', `url(${memberImgData[value].selected}) center no-repeat`)
    }
  })
  $('.member-equity').on('mouseleave', '.member-equity-box', (e) => {
    var el = $(e.currentTarget).find('.member-equity-box-image')
    var value = Number(el[0].dataset.value)
    if (memberData[value].type) {
      el.css('background', `url(${memberImgData[value].unselected}) center no-repeat`)
    }
  })
})



// WEBPACK FOOTER //
// ./src/js/entry/member/index.js